import React from "react";
import { Link } from "react-router-dom";
import { useData } from "@/context/DataContext";
import Seo from "@/components/site/Seo";
import { PageHero } from "@/components/site/Layout";

function LegalBody({ children }) {
  return (
    <section className="bg-av-black py-16 sm:py-24">
      <div className="mx-auto max-w-3xl px-5 sm:px-8 space-y-8 text-av-white/80 leading-relaxed">
        <div className="rounded-xl border border-av-bright/30 bg-av-green-dark/30 p-4 text-sm text-av-lime" style={{ backgroundColor: "rgba(22,56,29,0.3)" }}>
          Nota: la presente informativa è un modello generale. Si consiglia di farla verificare da un consulente per adeguarla pienamente alla normativa vigente.
        </div>
        {children}
      </div>
    </section>
  );
}
const H = ({ children }) => <h2 className="font-display text-2xl text-av-white pt-4">{children}</h2>;

export function PrivacyPolicy() {
  const { settings } = useData();
  return (
    <>
      <Seo title="Privacy Policy" description="Informativa sul trattamento dei dati personali di Animaverde." path="/privacy-policy" />
      <PageHero overline="Informativa" title="Privacy Policy" breadcrumb={<><Link to="/" className="hover:text-av-lime">Home</Link> / <span className="text-av-white">Privacy Policy</span></>} />
      <LegalBody>
        <H>Titolare del trattamento</H>
        <p>Il titolare del trattamento è <strong className="text-av-white">{settings?.ragione_sociale || "Animaverde"}</strong>{settings?.indirizzo ? `, con sede in ${settings.indirizzo}` : ""}{settings?.partita_iva ? ` — P.IVA ${settings.partita_iva}` : ""}. Dati di contatto: {settings?.email}, {settings?.telefono}.</p>
        <H>Dati raccolti</H>
        <p>Attraverso il modulo di contatto raccogliamo i dati che ci fornisci volontariamente: nome e cognome, numero di telefono, email, comune, tipologia di intervento, descrizione della richiesta ed eventuali fotografie allegate.</p>
        <H>Finalità del trattamento</H>
        <p>I dati sono trattati esclusivamente per rispondere alle richieste di contatto, organizzare sopralluoghi e fornire preventivi. Non vengono utilizzati per finalità di marketing senza un consenso specifico.</p>
        <H>Base giuridica e conservazione</H>
        <p>La base giuridica è il consenso dell'interessato e l'esecuzione di misure precontrattuali. I dati sono conservati per il tempo necessario a gestire la richiesta.</p>
        <H>Diritti dell'interessato</H>
        <p>Puoi richiedere in qualsiasi momento l'accesso, la rettifica o la cancellazione dei tuoi dati scrivendo a {settings?.email}.</p>
        <H>Cookie</H>
        <p>Per informazioni sull'utilizzo dei cookie consulta la <Link to="/cookie-policy" className="text-av-lime underline">Cookie Policy</Link>.</p>
      </LegalBody>
    </>
  );
}

export function CookiePolicy() {
  return (
    <>
      <Seo title="Cookie Policy" description="Informativa sull'uso dei cookie del sito Animaverde." path="/cookie-policy" />
      <PageHero overline="Informativa" title="Cookie Policy" breadcrumb={<><Link to="/" className="hover:text-av-lime">Home</Link> / <span className="text-av-white">Cookie Policy</span></>} />
      <LegalBody>
        <H>Cosa sono i cookie</H>
        <p>I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente, dove vengono memorizzati per essere ritrasmessi agli stessi siti alla visita successiva.</p>
        <H>Cookie utilizzati da questo sito</H>
        <p>Questo sito utilizza esclusivamente cookie tecnici necessari al corretto funzionamento (ad esempio per memorizzare le preferenze sul consenso). Non utilizziamo cookie di profilazione o di marketing senza il tuo consenso esplicito.</p>
        <H>Gestione delle preferenze</H>
        <p>Puoi modificare le tue preferenze in qualsiasi momento tramite il pulsante “Gestione preferenze cookie” presente nel footer del sito. Non attiviamo strumenti di tracciamento prima del consenso.</p>
        <H>Cookie di terze parti</H>
        <p>Previo il tuo consenso (pulsante “Accetta tutti”), questo sito utilizza <strong>Google Analytics 4</strong>, uno strumento di analisi statistica fornito da Google che ci aiuta a comprendere in forma aggregata come viene utilizzato il sito. Google Analytics installa cookie di terze parti e può trasferire dati verso i server di Google; l'indirizzo IP viene anonimizzato. Questi cookie non vengono attivati se scegli “Solo necessari”. Per maggiori informazioni puoi consultare l'informativa privacy di Google.</p>
        <p>Puoi revocare il consenso in qualsiasi momento tramite il pulsante “Gestione preferenze cookie” nel footer del sito.</p>
      </LegalBody>
    </>
  );
}

export default PrivacyPolicy;
